import { Settings } from "@/types/setting";
import { defineStore } from "pinia";

export const useSettingStore = defineStore("setting", {
  state: () => ({
    setting: {} as Settings | null,
  }),
  actions: {
    setSetting(setting: Settings) {
      this.setting = setting;
    },
  },
});
